module.exports = __webpack_public_path__ + "img/8.1-gallery.74b4f2c4.jpg";